import axios from 'axios';

export default async function deleteHandler(accessToken, id) {
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_HANDLERS_API_URL}/${id}`,
      requestOptions,
    );

    console.log(data);
    return data;
  } catch (err) {
    console.log(err);
    return null;
  }
}
